import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { NATIVE_APP_HELPER } from 'constants/native_app_helper.constants'

interface PlatformDetectionState {
  isMobileApp: boolean
}

const getInitialState = () => {
  const localStorageIsNativeApp = localStorage.getItem('isMobileApp')
  const environment = process.env.NODE_ENV
  if (localStorageIsNativeApp !== null && environment !== 'production') {
    return localStorageIsNativeApp === 'true'
  }
  // return Capacitor.isNativePlatform()
  return NATIVE_APP_HELPER.IS_NATIVE_PLATFORM
}

export const initialState: PlatformDetectionState = {
  isMobileApp: getInitialState()
}

const platformDetectionSlice = createSlice({
  name: 'platformDetection',
  initialState,
  reducers: {
    setIsMobileApp(state, action: PayloadAction<boolean>) {
      state.isMobileApp = action.payload
    }
  }
})

export const { setIsMobileApp } = platformDetectionSlice.actions

export default platformDetectionSlice.reducer
